// WILL BE DEPREACTED ONCE DataTable IS STANDARDIZED
// PLEASE USE DataTable instead of this!!!
// Generic Table VM meant to be used with display-table
// See webpack/view_models/instructor/coursework/index/index-vm.js for an example
// You may need to manually remove table items using prepUI for it to play nicely with pjax
export default function TableVM (data, node, params) {
  var self = this;
  self.defaults = {
    draggable: { enabled: false },
    removable: { enabled: false },
    dataset_name: 'table_data'
  };
  self.config = $.extend(true, {}, self.defaults, params);

  self.$el = $(node);
  self.$tbody = $(self.$el).find('.display-table__body');
  self.th_columns = ko.observableArray();
  self.override_column = ko.observable();
  self.rows_draggable = ko.observable(true);
  self.table_data = ko.observableArray(data[self.config.dataset_name]); //TODO: ko map this data
  self.table_properties = ko.mapping.fromJS(data, {ignore: [self.config.dataset_name]});
  if(!_.isEmpty(self.config.functions)){
    _.mapObject(self.config.functions, function(v, k) { return self[k] = v; });
  }
  self.descending = 'desc';
  self.ascending = 'asc';

  self.initUI = function(){
    var self = this;
    if(self.config.removable.enabled){
      $('.kd-ibtn--delete').on('click', function(evt) {
        Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('resource.delete.confirm'), function() {
          self.removeItem($(evt.target));
        });
        return false;
      });
    }
    self.setDraggable();
  };

  self.initDraggable = function () {
    self.$tbody.sortable({
      items: '.display-table__data',
      handle: '.display-table__sort-handle',
      helper: function (e, ui) {
        ui.children().each(function () {
          $(this).width($(this).width());
        });
        return ui;
      },
      update: function (e, ui) {
        self.resequenceItems(self.$tbody, self.config.draggable.update_url, true);
      }
    });
  };

  self.setDraggable = function () {
    if(self.rows_draggable()){
      self.$tbody.sortable('enable');
    } else {
      self.$tbody.sortable('disable');
    }
  };

  this.removeItem = $ele => {
    //
    // TODO: find parents more dynamically
    //
    Kadenze.Ajax.delete({
      $element: $ele,
      $parent: $ele.parents()[3],

      done: data => {
        if (this.$tbody.children().length && this.config.draggable.update_url)
          this.resequenceItems(this.$tbody, this.config.draggable.update_url, false)
      },
    })
  }

  self.resequenceItems = function($table_body, url, dragging) {
    dragging = dragging || false;
    var request = new Kadenze.AjaxRequest({
      url: url,
      type: 'POST',
      dataType: 'text',
      dataAsJSON: false,
      data: $table_body.sortable('serialize'),
      loadingIndicator: {
        container: '#main-container'
      }
    });

    request.done(function(data, textStatus, xhr) {
      var $trs = $table_body.children();

      $trs.each(function () {
        var $tr = $(this);
        var newVal = ($tr.index() + 1);
        $tr.find('.tbl-resequence-col').html(newVal);
      });
    });

    request.fail(function(xhr, textStatus, errorThrown) {
      if(dragging) {
        self.$tbody.sortable('cancel');
      }

      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
    });
  };

  self.sortClick = function (column, $el) {
    var $caret = $el.find('.kf-back-arrow');
    self.clearColumnDirections(column);
    $caret.removeClass('hidden');
    if (column.direction() === self.descending) {
      $caret.addClass('up').removeClass('down');
      column.direction(self.ascending);
      self.rows_draggable(column.dragOverride);
    } else {
      $caret.addClass('down').removeClass('up');
      column.direction(self.descending);
      if(column.dragOverride){
        self.rows_draggable(false);
      }
    }

    var sorted = _.sortBy(self.table_data(), function(data) {
      if (column.type == 'date') {
        return new Date(self.getFormattedDate(data[column.property]));
      } else if (column.type == 'string') {
        return data[column.property].toLowerCase();
      } else {
        return data[column.property];
      }
    });

    sorted = (column.direction() === self.descending) ? sorted.reverse() : sorted;
    self.table_data(sorted);
  };

  self.clearColumnDirections = function (column) {
    $('.kf-back-arrow').addClass('hidden');
    var filteredCols = _.each(this.th_columns(), function(col) { if(col != column) { col.direction(self.descending); } });
    this.th_columns(filteredCols);
  };

  self.getFormattedDate = function(date){
    return moment(date, Kadenze.I18n.t('date.formats.js_source_default')).format(Kadenze.I18n.t('date.formats.js_default'));
  };

  self.previewItem = function(item, event) {
    if (_.isObject(item.blocked_modal)) {
      new Kadenze.Notice.info(item.blocked_modal);
      return false;
    }
    Kadenze.MediaFileActions.preview(item);
  };

  self.playItem = function(item, event) {
    if (_.isObject(item.blocked_modal)) {
      new Kadenze.Notice.info(item.blocked_modal);
      return false;
    }
    console.log('Play:', item );
    Kadenze.MediaFileActions.play(item);
  };

  const __construct = function (that) {
    console.log('constructor called for Kadenze.Table');
    if(self.config.draggable) {
      that.initDraggable();
    }
  }(this);
}

